/* eslint-disable no-shadow */
export enum ShippingChargeEnum {
  included = 'P',
  notIncluded = 'S',
  noCharge = 'N',
}
/* eslint-enable no-shadow */
